<template>
  <div class="training-container light">
    <div class="content">
      <div class="swiper-group">
        <div class="swiper-header">银都奥美大讲堂</div>
        <div class="custom-swiper-container">
          <swiper :options="options" class="custom-swiper">

            <swiper-slide class="custom-swiper-slide" v-for="(articles,index) in articleGroup" :key="index">

              <div class="swiper-box" v-for="(article,index) in articles" :key="index" data-swiper-parallax='-200'>
                <div class="swiper-box-container">
                  <div class="pic">
                    <img :src="resources[article.thumb].src"/>
                  </div>
                  <div class="title">{{article.title}}</div>
                  <div class="desc">{{article.desc}}</div>
                </div>
              </div>
            </swiper-slide>

          </swiper>
          <div class="button-next inner-button-next" slot="button-next">
            more>
          </div>
        </div>
       
      </div>

      <div class="swiper-group">
        <div class="swiper-header">海外拓展计划</div>
        <div class="custom-swiper-container">
          <swiper :options="options2" class="custom-swiper custom-swiper-outer">

            <swiper-slide class="custom-swiper-slide" v-for="(outers,index) in outerGroup" :key="index">

              <div class="swiper-box" v-for="(outer,index) in outers" :key="index" data-swiper-parallax='-200'>
                <div class="swiper-box-container">
                  <div class="pic">
                    <img :src="resources[outer.thumb].src"/>
                  </div>
                </div>
              </div>
            </swiper-slide>
            
          </swiper>
          <div class="button-next outer-button-next" slot="button-next ">
            more>
          </div>
        </div>
        
       
      </div>

    </div>
    <yindu-article :close="closed" @closeDialog='closeDialog' :article="article"></yindu-article>
  </div>
</template>
<script>
import YinduArticle from '../components/YinduArticle.vue';
import {chunk} from "loadsh";
import {training,outer} from '../api/training';
import {swiper , swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
const SWIPEROPTIONS = {
  parallax:true,
  noSwiping:true,
  loop:true,
  noSwipingClass:'custom-swiper-slide',
  speed:1500,
  lazy:true,
  resources:null
};
export default {
  data(){
    return {
      options:{...SWIPEROPTIONS,navigation:{nextEl:'.inner-button-next'}},
      options2:{...SWIPEROPTIONS,navigation:{nextEl:'.outer-button-next'}},
      article:null,
      articleGroup:[],
      outerGroup:[],
      closed: true
    }
  },
  components:{
    swiper,
    swiperSlide,
    YinduArticle
  },
  created(){
    // console.log(this.options == this.options2)
    this.resources = this.$store.state.resources;
    this.articleGroup = chunk(training,5);
    this.outerGroup = chunk(outer,2);
  },
  methods:{
    test(){
      // alert(1);
    },
    closeDialog(){
      this.closed = true;
    },
    openDialog({thumb,img,title,desc,content}){
      let {resources} = this;
      this.closed = false;
      this.article = {
        thumb: resources[thumb].src ,
        img: resources[img].src  || resources[thumb].src,
        title,
        desc,
        content
      };
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../common/common.scss";
.training-container {
  min-width: 1200px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  width: 100%;
  box-sizing: border-box;
  padding-right: 187px;
}
.button-next {
  position: absolute;
  right: -58px;
  top: 50%;
  transform: translate3d(0,-50%,0);
  text-transform: uppercase;
  cursor: pointer;
  font-size: px2rem(18);
}
.custom-swiper-container {
  width: 100%;
  position: relative;
}
.swiper-group + .swiper-group {
  margin-top: 50px;
}
.custom-swiper {
  width: 100%;
}
.custom-swiper-slide {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.custom-swiper-outer {
  
  .swiper-box {
    width: px2percent(498,1013);
    .pic {
      padding: px2percent(192/2,498) 50% ;
    }
    
  }
}
.swiper-box {
  cursor: pointer;
  width: px2percent(188,1013);
  box-sizing: border-box;
  .swiper-box-container {
    width: 100%;
    box-sizing: border-box;
    padding: 6px;
    background: #fff;
    transition: all .2s linear;
    &:active {
      transform: scale(.96);
      
    }
  }
  .pic {
    padding: px2percent(124/2,207) 50% ;
    position: relative;
    overflow: hidden;
    img {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
    }
  }
  .title {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 8px auto;
  }
  .desc {
    font-size: 12px;
    line-height: 1.5;
    height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.swiper-header {
  padding-left: 10px;
  font-size: px2rem(24);
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 7px;
    background: #ed2024;
  }
}
</style>
